<div class="branding-container">
  <div class="section">
    <h3>Logo Management</h3>
    <div class="logo-section">
      <!-- Show current logo with remove button when logo exists -->
      @if (getLogoDisplayUrl()) {
        <div class="current-logo">
          <h4>Current Logo</h4>
          <div class="logo-preview">
            <img [src]="getLogoDisplayUrl()" alt="Current Logo" class="logo-image" />
          </div>
          <p-button
            label="Remove Logo"
            icon="pi pi-trash"
            severity="danger"
            size="small"
            (onClick)="removeLogo()"
            />
        </div>
      }

      <!-- Show upload section only when no logo exists -->
      @if (!getLogoDisplayUrl()) {
        <div class="upload-section">
          <h4>Upload Logo</h4>
          <p-fileUpload
            mode="basic"
            chooseLabel="Choose SVG File"
            [chooseIcon]="isUploading ? 'pi pi-spin pi-spinner' : 'pi pi-upload'"
            accept=".svg,image/svg+xml"
            maxFileSize="1048576"
            [auto]="false"
            customUpload="true"
            (onSelect)="onFileSelect($event)"
            [disabled]="isUploading"
            />
          <p class="upload-hint">
            Only SVG files are allowed. Maximum file size: 1MB
          </p>
        </div>
      }
    </div>
  </div>

  <p-divider />

  <div class="section">
    <h3>Small Logo Management</h3>
    <div class="logo-section">
      <!-- Show current small logo with remove button when small logo exists -->
      @if (getLogoDisplayUrl('smallLogo')) {
        <div class="current-logo">
          <h4>Current Small Logo</h4>
          <div class="logo-preview">
            <img [src]="getLogoDisplayUrl('smallLogo')" alt="Current Small Logo" class="logo-image" />
          </div>
          <p-button
            label="Remove Small Logo"
            icon="pi pi-trash"
            severity="danger"
            size="small"
            (onClick)="removeLogo('smallLogo')"
            />
        </div>
      }

      <!-- Show upload section only when no small logo exists -->
      @if (!getLogoDisplayUrl('smallLogo')) {
        <div class="upload-section">
          <h4>Upload Small Logo</h4>
          <p-fileUpload
            mode="basic"
            chooseLabel="Choose SVG File"
            [chooseIcon]="isSmallLogoUploading ? 'pi pi-spin pi-spinner' : 'pi pi-upload'"
            accept=".svg,image/svg+xml"
            maxFileSize="1048576"
            [auto]="false"
            customUpload="true"
            (onSelect)="onSmallLogoSelect($event)"
            [disabled]="isSmallLogoUploading"
            />
          <p class="upload-hint">
            Only SVG files are allowed. Maximum file size: 1MB
          </p>
        </div>
      }
    </div>
  </div>

  <p-divider />

  <div class="section">
    <div class="color-picker-header">
      <h3>Theme Colors</h3>
      <div class="header-actions">
        @if (isSaving) {
          <span class="saving-indicator">
            <i class="pi pi-spin pi-spinner"></i>
            Saving...
          </span>
        }
        <p-button
          label="Reset to Defaults"
          icon="pi pi-refresh"
          severity="secondary"
          size="small"
          (onClick)="resetToDefaults()"
          />
      </div>
    </div>

    <div class="color-grid">
      <div class="color-item">
        <div class="color-label">
          <label for="primaryColor">{{ colorLabels.primaryColor }}</label>
          <p class="color-description">{{ colorDescriptions.primaryColor }}</p>
        </div>
        <div class="color-input">
          <p-colorPicker
            id="primaryColor"
            [ngModel]="getColorValue('primaryColor')"
            (onChange)="onColorPickerChange('primaryColor', $event.value)"
            format="hex"
            [inline]="false"
            [appendTo]="'body'"
            />
          <input
            type="text"
            [value]="getColorValue('primaryColor')"
            (input)="onColorChange('primaryColor', $any($event.target).value)"
            class="color-input-text"
            placeholder="#FDE047"
            />
        </div>
      </div>
    </div>
  </div>
</div>
